import assetsBase from '@exodus/assets-base'
import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

const assets = assetsBase.default || assetsBase

export const MOONPAY_API_URL = 'https://api.moonpay.com'

export const ENABLED_SELL_ASSETS = {
  __proto__: null,
  eur: 'eur',
  gbp: 'gbp',
  usd: 'usd',
}

export const ENABLED_ASSETS = {
  __proto__: null,
  aave: assets.aave?.name,
  ada: assets.cardano?.name,
  algo: assets.algorand?.name,
  atom: assets.cosmos?.name,
  avax_cchain: assets.avalanchec?.name,
  axs: assets.axieinfinity?.name,
  bat: assets.bat?.name,
  bch: assets.bcash?.name,
  bnb: assets.bnbmainnet?.name,
  bnb_bsc: assets.bsc?.name,
  btc: assets.bitcoin?.name,
  busd: assets.busd_bnbmainnet?.name,
  busd_bsc: assets.busd_bsc?.name,
  comp: assets.compound?.name,
  dash: assets.dash?.name,
  dgb: assets.digibyte?.name,
  doge: assets.dogecoin?.name,
  dot: assets.polkadot?.name,
  egld: assets.elrond?.name,
  enj: assets.enjincoin?.name,
  eos: assets.eosio?.name,
  eth_base: assets.basemainnet?.name,
  eth_optimism: assets.optimism?.name,
  eth_polygon: assets.weth_matic?.name,
  dai: assets.mcd?.name,
  etc: assets.ethereumclassic?.name,
  eth: assets.ethereum?.name,
  eth_arbitrum: assets.ethereumarbone?.name,
  fil: assets.filecoin?.name,
  hbar: assets.hedera?.name,
  imx: assets.imx?.name,
  kava: assets.kava?.name,
  link: assets.chainlink?.name,
  ltc: assets.litecoin?.name,
  mana: assets.decentraland?.name,
  pol: assets.pol_ethereum_e5c9fadc?.name,
  pol_polygon: assets.matic?.name,
  mkr: assets.maker?.name,
  ont: assets.ontology?.name,
  qtum: assets.qtum?.name,
  rvn: assets.ravencoin?.name,
  sand: assets.sandbox?.name,
  shib: assets.shibainu?.name,
  sol: assets.solana?.name,
  stmx: assets.stormx?.name,
  trx: assets.tronmainnet?.name,
  tusd: assets.trueusd?.name,
  uni: assets.uniswap?.name,
  usdc: assets.usdcoin?.name,
  usdc_base: assets.usdc_basemainnet_b5a52617?.name,
  usdc_optimism: assets.usdc_optimism_68bb70cd?.name,
  usdc_polygon: assets.usdc_matic_0a883d9b?.name,
  usdc_sol: assets.usdcoin_solana?.name,
  usdt: assets.tetherusd?.name,
  usdt_bsc: assets.usdt_bsc_ddedf0f8?.name,
  usdt_trx: assets.tetherusd_tron?.name,
  vet: assets.vechainthor?.name,
  wbtc: assets.wbtc?.name,
  xem: assets.nem?.name,
  xlm: assets.stellar?.name,
  xno: assets.nano?.name,
  xrp: assets.ripple?.name,
  xtz: assets.tezos?.name,
  zec: assets.zcash?.name,
  zil: assets.zilliqa?.name,
  snx: assets.snx?.name,
}

export const ENABLED_TEST_ASSETS = {
  __proto__: null,
  btc: 'bitcointestnet',
  eth: 'ethereumsepolia',
}

export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  ach_bank_transfer: 'ach_bank_transfer',
  credit_debit_card: 'credit_debit_card',
  gbp_bank_transfer: 'gbp_bank_transfer',
  gbp_open_banking_payment: 'gbp_open_banking_payment',
  mobile_wallet: 'mobile_wallet',
  paypal: 'paypal',
  pix_instant_payment: 'pix_instant_payment',
  sepa_bank_transfer: 'sepa_bank_transfer',
  venmo: 'venmo',
  yellow_card_bank_transfer: 'yellow_card_bank_transfer',
}

export const PAYMENT_METHODS = new Map([
  [
    PAYMENT_METHOD_NAMES.mobile_wallet,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.mobile_wallet,
      type: [PAYMENT_METHOD_TYPES.apple_pay, PAYMENT_METHOD_TYPES.google_pay],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.credit_debit_card,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.credit_debit_card,
      type: PAYMENT_METHOD_TYPES.card,
      orderTypes: ['buy', 'sell'],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.ach_bank_transfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.ach_bank_transfer,
      type: PAYMENT_METHOD_TYPES.bank,
      currencies: [{ id: 'USD', enabled: true }],
      orderTypes: ['buy', 'sell'],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.paypal,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.paypal,
      type: PAYMENT_METHOD_TYPES.paypal,
      countries: [{ id: 'US', enabled: true }],
      currencies: [{ id: 'USD', enabled: true }],
      orderTypes: ['buy'],
      apps: [{ id: 'magic-eden', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.pix_instant_payment,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.pix_instant_payment,
      type: PAYMENT_METHOD_TYPES.pix,
      currencies: [{ id: 'BRL', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.sepa_bank_transfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.sepa_bank_transfer,
      type: PAYMENT_METHOD_TYPES.bank,
      currencies: [{ id: 'EUR', enabled: true }],
      orderTypes: ['buy', 'sell'],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.gbp_bank_transfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.gbp_bank_transfer,
      type: PAYMENT_METHOD_TYPES.bank,
      currencies: [{ id: 'GBP', enabled: true }],
      orderTypes: ['buy', 'sell'],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.venmo,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.venmo,
      type: PAYMENT_METHOD_TYPES.venmo,
      countries: [{ id: 'US', enabled: true }],
      currencies: [{ id: 'USD', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.yellow_card_bank_transfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.yellow_card_bank_transfer,
      type: PAYMENT_METHOD_TYPES.bank,
      currencies: [{ id: 'NGN', enabled: true }],
    }),
  ],
])

export const ORDER_STATUSES = {
  __proto__: null,
  completed: 'completed',
  failed: 'failed',
  pending: 'pending',
  waiting_authorization: 'waitingAuthorization',
  waiting_deposit: 'waitingForDeposit',
  waiting_payment: 'waitingPayment',
}

export const EXODUS_ORDER_STATUSES = {
  __proto__: null,
  complete: [ORDER_STATUSES.completed],
  failed: [ORDER_STATUSES.failed],
  'in-progress': [
    ORDER_STATUSES.waiting_payment,
    ORDER_STATUSES.pending,
    ORDER_STATUSES.waiting_authorization,
    ORDER_STATUSES.waiting_deposit,
  ],
}

export const DEFAULT_FIAT_PRECISION = 2
export const DEFAULT_CRYPTO_PRECISION = 4
